import { render } from "./CorrectionForm.vue?vue&type=template&id=26c39694&scoped=true"
import script from "./CorrectionForm.vue?vue&type=script&lang=js"
export * from "./CorrectionForm.vue?vue&type=script&lang=js"

import "./CorrectionForm.vue?vue&type=style&index=0&id=26c39694&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c39694"]])

export default __exports__